import { LegalEntitiesActionTypes } from '../actions';
import {
  FETCH_LEGAL_ENTITIES,
  FETCH_LEGAL_ENTITIES_FAILURE,
  FETCH_LEGAL_ENTITIES_SUCCESS
} from '../constants';

export interface LegalEntitiesState {
  data: {
    eid: string;
    name: string;
    formalName: string;
    regNumber: string;
    address: string;
    country: string;
    cratedAt: string | null;
  }[];
  loading: boolean;
  error: string | null;
}

const initialState: LegalEntitiesState = {
  data: null,
  loading: false,
  error: null
};

export function legalEntitiesReducer(
  state = initialState,
  action: LegalEntitiesActionTypes
): LegalEntitiesState {
  switch (action.type) {
    case FETCH_LEGAL_ENTITIES:
      return { ...state, loading: true, error: null };
    case FETCH_LEGAL_ENTITIES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_LEGAL_ENTITIES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
